export default "__VITE_ASSET__CqhCMjXb__"